import '@splidejs/splide/css/core'
import './components/g-web-components'

import 'virtual:shopify-modules'

// All
//import "./components/measure";
import '../scss/main.scss'
import './components/address-list'
import './components/announcement-bar'
import './components/favourite-product'
import './components/featured-picks-carousel'
import './components/footer'
import './components/g-carousel'
import './components/g-cart'
import './components/g-collapsible-tags'
import './components/g-collapsible-text'
import './components/g-dropdown'
import './components/g-header'
import './components/g-hero'
import './components/g-modal'
import './components/g-number-input'
import './components/g-product-item'
import './components/g-buy-button'
import './components/header-menu'
import './components/hide-banner'
import './components/measure'
import './components/recently-viewed-products'
import './components/scroll-header'
import './components/varify'
// Searchbar
import './components/header-searchbar'
import './components/suggestion-list'
// Home
import './components/product-recommendations'
import './components/recommendation-carousel-by-order'
// Cart
import './components/cart-progress-bar'
import './components/cart-product-state-selector'
import './components/cart-recommendations'
import './components/cart-timer'
import './components/intelligent-bookseller';
import './components/intelligent-bookseller-suggestion-item';
// Quickview
import './components/products-same-author'
// Delivery
import './components/delivery-modal'

updateProductHref()

function updateProductHref() {
  const productHref = window.location.pathname
  let nextURL = window.location.origin

  if (document.body.classList.contains('js-product-not-found') && productHref.includes('products')) {
    const productId = productHref.split('/').pop().split('-')[0]
    const productNumber = +productHref.split('/').pop().split('-')[1] || 0

    if (productNumber >= 10) {
      return
    }

    nextURL = nextURL + `/products/${productId}-${productNumber + 1}`

    window.location.href = nextURL
  }
}

window._learnq = window._learnq || []
